import { useEffect, useState } from "react";
import { dataAwaitProp } from "./props";
import { useRequest, useUnmount } from "ahooks";
import { getVideoSimilarDataMergeApi } from "@/services";
import { message } from "antd";
import { useVideoStore } from "@/store";
import { useThemeStyles } from "@/components";
import { useVideoGenerateStateStore } from "@/store/videoGenerateStateLocal";

const useAction = () => {
  // 本地生成的视频存储,主题颜色
  const { myTheme } = useThemeStyles();
  // 全局状态管理
  const [
    createSelectPageDataAwaitList,
    settingStyleData,
    setCreateSelectPageDataAwaitList,
  ] = useVideoStore((state) => [
    state.createSelectPageDataAwaitList,
    state.settingStyleData,
    state.setCreateSelectPageDataAwaitList,
  ]);

  // 存储视频进度列表
  const [createSelectPageTask, setCreateSelectPageTask] =
    useVideoGenerateStateStore((state) => [
      state.createSelectPageTask,
      state.setCreateSelectPageTask,
    ]);

  const [videoDataAwait, videoDataAwaitAction] = useState<dataAwaitProp[]>(
    () => createSelectPageDataAwaitList.videoDataAwait
  );

  const [loading, loadingAction] = useState<boolean>(false);
  const [languageNum, languageNumAction] = useState<number[] | undefined>(
    settingStyleData.createSelectTask.text_select_video_voice
  );
  const [bgmNum, bgmNumAction] = useState<number>(
    settingStyleData.createSelectTask.text_select_video_bgc_music
  );
  const [subtitleSelectValue, subtitleSelectValueAction] = useState<string[]>(
    settingStyleData.createSelectTask.text_select_video_subtitle
  );
  const [speechRate, speechRateAction] = useState<number>(
    settingStyleData.createSelectTask.text_select_video_speaking_speed
  );
  const [videoListName, videoListNameAction] = useState<string>("");

  useUnmount(() => {
    setCreateSelectPageDataAwaitList({
      videoDataAwait: videoDataAwait,
    });
  });

  const onChangeSpeakingSpeed = (value: number) => {
    speechRateAction(value);
  };

  const onChange = (valueList?: number[]) => {
    languageNumAction(valueList);
  };

  const onChangeBgm = (value: number) => {
    bgmNumAction(value);
  };

  const onChangeSubtitle = (value: string[]) => {
    subtitleSelectValueAction(value);
  };

  // 检查是否填写必选项
  const generateCheck = () => {
    if (
      subtitleSelectValue.length &&
      typeof speechRate !== "undefined" &&
      typeof bgmNum !== "undefined" &&
      typeof languageNum !== "undefined"
    ) {
      return true;
    }
    return false;
  };

  const generateVideo = (videoName: string) => {
    loadingAction(true);
    videoListNameAction(videoName);
    const list = videoDataAwait.map((item) => ({
      ...item,
      voice: languageNum?.[languageNum?.length - 1] as number,
    }));
    generateVideoRequest.run({
      source: list,
      bgm: bgmNum as number,
      subtitles: {
        main: subtitleSelectValue[0] ?? "",
        second: subtitleSelectValue[1] ?? "",
      },
      speech_rate: typeof speechRate !== "undefined" ? speechRate : 0,
    });
  };

  const generateVideoRequest = useRequest(getVideoSimilarDataMergeApi, {
    manual: true,
    onSuccess(result) {
      loadingAction(false);
      message.success("success");
      if (!!result.data.task_id) {
        setCreateSelectPageTask({
          ...createSelectPageTask,
          video: {
            tasks: [
              ...createSelectPageTask.video.tasks,
              {
                id: result.data.task_id,
                name: videoListName,
                isGenerate: false,
                state: 0,
                time: result.data.task_time,
              },
            ],
          },
        });
      }
    },
    onError(e) {
      loadingAction(false);
      message.error("error");
    },
  });

  useEffect(() => {
    bgmNumAction(settingStyleData.createSelectTask.text_select_video_bgc_music);
    languageNumAction(
      settingStyleData.createSelectTask.text_select_video_voice
    );
    subtitleSelectValueAction(
      settingStyleData.createSelectTask.text_select_video_subtitle
    );
    speechRateAction(
      settingStyleData.createSelectTask.text_select_video_speaking_speed
    );
  }, [settingStyleData.createSelectTask]);

  return {
    videoDataAwait,
    loading,
    subtitleSelectValue,
    myTheme,
    bgmNum,
    languageNum,
    speechRate,
    videoDataAwaitAction,
    generateVideo,
    onChange,
    onChangeBgm,
    onChangeSubtitle,
    onChangeSpeakingSpeed,
    generateCheck,
  };
};

export default useAction;
